<template>
	<div id="intro-screen-container">
		<img id="intro-img" class="intro-img" width="637" v-bind:src="require(`@/assets/${content[which].main}`)" />
		<PageArrows v-if="content[which].link" v-bind:linkNext="content[which].link"></PageArrows>

		<div id="calendar-buttons" v-if="which === 'calendars'">
			<router-link v-bind:to="'/calendars/ven-g/'">
				<img width="195" height="63" v-bind:src="require(`@/assets/calendars/intro/button-ven-g.png`)" />
			</router-link>
			<router-link v-bind:to="'/calendars/ven-r/'">
				<img width="195" height="63" v-bind:src="require(`@/assets/calendars/intro/button-ven-r.png`)" />
			</router-link>
		</div>

	</div>
	<div id="footnote-container" v-if="content[which].footnote">
		<img id="footnote-img" class="intro-img" height="36" v-bind:src="require(`@/assets/${content[which].footnote}`)" />
	</div>
	<teleport to="body">
		<OverviewScreens
			v-if="overviewActive"
			v-bind:which="content[which].si"
			v-on:close-overview="closeSI"
		/>
	</teleport>
</template>
<script>
import PageArrows from '@/components/PageArrows'
import OverviewScreens from '@/components/OverviewScreens'
export default {
	components: {
		PageArrows,
		OverviewScreens
	},
	data() {
		return {
			which: this.$route.params.which,
			overviewActive: false,
			content: {
				bishop: {
					main: 'patients/bishop/intro/intro.png',
					footnote: 'patients/bishop/intro/intro-copy.png',
					link: '/patient/bishop/diagnosis/',
					si: 'cll'
				},
				carson: {
					main: 'patients/carson/intro/intro.png',
					footnote: 'patients/carson/intro/intro-copy.png',
					link: '/patient/carson/diagnosis/',
					si: 'aml'
				},
				gordon: {
					main: 'patients/gordon/intro/intro.png',
					footnote: 'patients/gordon/intro/intro-copy.png',
					link: '/patient/gordon/diagnosis/',
					si: 'cll'
				},
				pierce: {
					main: 'patients/pierce/intro/intro.png',
					footnote: 'patients/pierce/intro/intro-copy.png',
					link: '/patient/pierce/diagnosis/',
					si: 'aml'
				},
				neutropenia: {
					main: 'neutropenia/intro/intro.png',
					link: '/neutropenia/',
					si: 'aml'
				},
				calendars: {
					main: 'calendars/intro/intro.png',
					si: 'cll'
				}
			}
		}
	},
	methods: {
		closeSI(which){
			this.$store.dispatch('overviewSeen',which)
			this.overviewActive = false
			this.openSIclass = false
		}
	},
	mounted(){
		let siStatus = this.$store.getters.siAccessed[this.content[this.which].si]
		if(siStatus === false){
			this.overviewActive = true
		}
	}
}
</script>
<style scoped>
#intro-screen-container {
	position: relative;
	width: 100%;
	height: 100%;
}

	.intro-img {
		display: block;
		margin: 0 auto;
		text-align: center;
	}

	#calendar-buttons {
		display: flex;
		justify-content: center;
		margin: 0 auto;
		padding-top: 30px;
	}

		#calendar-buttons img {
			display: block;
			margin: 0 12px;
		}

#footnote-container {
	right: 0;
	bottom: 42px;
	left: 0;
	position: fixed;
}
</style>